import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import LoginCardComponent from "../login-card/login-card.component";
import { RouterModule } from "@angular/router";

@Component({
  selector: "app-header",
  imports: [CommonModule, LoginCardComponent, RouterModule],
  templateUrl: "./header.layout.html",
  styleUrl: "./header.layout.scss",
})
export class HeaderLayout {}
